import { render, staticRenderFns } from "./comment-card.vue?vue&type=template&id=257782d1"
import script from "./comment-card.vue?vue&type=script&lang=js"
export * from "./comment-card.vue?vue&type=script&lang=js"
import style0 from "./comment-card.vue?vue&type=style&index=0&id=257782d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports